import React from 'react';
import Switch from '@material-ui/core/Switch';
import { IOSSwitchStyles } from "./style";

const IOSSwitch = (props) => {
  const classes = IOSSwitchStyles();

  return (
    <Switch
      disableRipple
      focusVisibleClassName={classes.focusVisible}
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
        disabled: classes.disabled,
      }}
      {...props}
    />
  );
};

export default IOSSwitch;
